import React, { useContext, useEffect } from "react";
import RoomContext from "../context/RoomContext";
import { useParams } from "react-router";
import { useSelector } from "react-redux";
import Room from "./Room/Room";
import LoadingView from "./Common/LoadingView";
import AudioPeers from "./PeerAudio/AudioPeers";
import { makeStyles } from "@material-ui/core";
import { RawIntlProvider } from "react-intl";
import { generateIntl } from "../intl";

let attemptCheckAuth = false;
const useStyles = makeStyles({
  fullView: {
    width: "100vw",
    height: "100vh",
    top: 0,
    zIndex: 999,
  },
});
const LightRoom = () => {
  const classes = useStyles();
  const { id } = useParams();
  const { token, audio, video, roomName } = useQueryParams();
  const room = useSelector((state) => state.room);
  const isAuthenticated = useSelector((state) => state.me.loggedIn === true);
  const userLanguage = useSelector((state) => state.user.userLanguage);

  const { apiServiceClient, roomClient } = useContext(RoomContext);

  function useQueryParams() {
    const params = new URLSearchParams(window ? window.location.search : {});

    return new Proxy(params, {
      get(target, prop) {
        return target.get(prop);
      },
    });
  }
  const intl = generateIntl();

  useEffect(() => {
    roomClient.setIntl(intl);
  }, [userLanguage]);

  if (token) {
    localStorage.setItem("token", token);
  }

  if (!attemptCheckAuth) {
    apiServiceClient.checkAuth(id);
    attemptCheckAuth = true;
  }

  if (isAuthenticated) {
    if (
      id &&
      id !== "undefined" &&
      audio &&
      audio !== "undefined" &&
      video &&
      video !== "undefined" &&
      !room.joined
    ) {
      roomClient.join({
        roomId: id,
        roomName,
        joinAudio: audio === "true",
        joinVideo: video === "true",
      });
      return <LoadingView />;
    } else if (room.joined) {
      return (
        <RawIntlProvider value={intl}>
          <div className={classes.fullView}>
            <Room />
            <AudioPeers />
          </div>
        </RawIntlProvider>
      );
    }
  } else return <LoadingView />;
  return <LoadingView />;
};

export default LightRoom;
